import "core-js/modules/es.number.constructor";
import "core-js/modules/es.object.to-string";
import "core-js/modules/es.promise";
import styles from '../shared/styles/global.scss';
import isBrowser from './isBrowser';
export var HTML_LOCK_CLASS = styles.htmlScrollLock;
export var BODY_LOCK_CLASS = styles.bodyScrollLock;
var lockersStack = 0;
var scrollPosition = 0;
var isScrollLocked = false;
var body = isBrowser ? document.body : null;
var html = isBrowser ? document.documentElement : null; // Get/Set Scroll Lock value

export var getScrollLocked = function getScrollLocked() {
  return isScrollLocked;
};

var setIsScrollLocked = function setIsScrollLocked(newValue) {
  isScrollLocked = newValue;
}; // Position scroll helpers


export var getScrollPosition = function getScrollPosition() {
  if (!isBrowser || !html || !body) return 0;

  if (!isScrollLocked) {
    scrollPosition = window.pageYOffset || html.scrollTop || body.scrollTop || 0;
  }

  return scrollPosition;
};
export var setScrollPosition = function setScrollPosition(scroll) {
  if (!isBrowser || !html || !body) return;

  if (isScrollLocked) {
    scrollPosition = scroll;
    body.style.top = "-".concat(scroll, "px");
  } else {
    window.scrollTo(0, scroll);
  }
};
export var lockScroll = function lockScroll() {
  if (!isBrowser || !html || !body) return;
  lockersStack += 1;
  if (lockersStack > 1) return;
  var scroll = getScrollPosition();
  setIsScrollLocked(true);
  html.classList.add(HTML_LOCK_CLASS);
  body.classList.add(BODY_LOCK_CLASS);
  body.style.top = "-".concat(scroll, "px");
}; // Scroll Unlocker

export var unlockScroll = function unlockScroll() {
  if (!isBrowser || !html || !body) return;
  lockersStack -= 1;
  if (lockersStack > 0) return;
  html.classList.remove(HTML_LOCK_CLASS);
  body.classList.remove(BODY_LOCK_CLASS);
  body.style.top = '';
  var scroll = getScrollPosition();
  window.scrollTo(0, scroll);
  setIsScrollLocked(false);
}; // Toggle

export var setScrollLock = function setScrollLock(newLockState) {
  if (newLockState) {
    lockScroll();
  } else {
    unlockScroll();
  }

  return function () {
    unlockScroll();
  };
}; // Animate Scroll

var animateRafId;
export var animateScroll = function animateScroll(to) {
  var duration = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 350;
  return new Promise(function (resolve) {
    if (animateRafId) {
      window.cancelAnimationFrame(animateRafId);
      animateRafId = undefined;
    }

    var start = getScrollPosition();
    var distance = to - start;
    var startTime;

    if (distance === 0 || isScrollLocked) {
      if (isScrollLocked) setScrollPosition(start + distance);
      resolve();
      return;
    }

    var animateScrollLoop = function animateScrollLoop(time) {
      if (!startTime) startTime = time;
      var currentTime = time - startTime;
      var prog = currentTime / duration;
      window.scrollTo(0, start + prog * distance);

      if (currentTime < duration) {
        animateRafId = window.requestAnimationFrame(animateScrollLoop);
      } else {
        animateRafId = undefined;
        resolve();
      }
    };

    animateRafId = window.requestAnimationFrame(animateScrollLoop);
  });
}; // History scroll helpers

export var SCROLL_STORAGE_PREFIX = 'saved-scroll-';
var preventScrollRestoring = false;
export var saveScrollHistory = function saveScrollHistory() {
  var key = JSON.stringify(window.history.state);
  sessionStorage.setItem(SCROLL_STORAGE_PREFIX + key, String(getScrollPosition()));
};
export var preventNextScrollRestoring = function preventNextScrollRestoring() {
  preventScrollRestoring = true;
};
export var restoreScrollHistory = function restoreScrollHistory() {
  if (preventScrollRestoring) {
    preventScrollRestoring = false;
    return;
  }

  var key = JSON.stringify(window.history.state);
  var top = Number(sessionStorage.getItem(SCROLL_STORAGE_PREFIX + key) || 0);
  setScrollPosition(top);
};